module.exports = __webpack_public_path__ + "img/performa_dex_asesmen.2a9da5c7.svg";